import styled from 'styled-components'
import { fontSize } from 'Constants'

export const Text = styled.span`
  font-size: ${fontSize.default};
  color: ${p => p.theme.palette.black};
`
